// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"961":"e0a66aa547808012ab27","5338":"bf07dfd93263478a555c"}[chunkId] + ".js";
};